import { useEffect, useState } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { getMembershipInfo, IMembership } from '@fff-web/fff-utilities';

export function useMembershipInfo() {
  const [membershipInfo, setMembershipInfo] = useState<IMembership>({} as IMembership);

  useEffect(() => {
    try {
      getMembershipInfo().then((info) => setMembershipInfo(info));
    } catch (error) {
      datadogLogs.logger.error('Unable to get Membership Info', {}, error as Error);
      return;
    }
  }, []);

  return {
    membershipInfo,
  };
}

export default useMembershipInfo;
